import './App.css';
import Layout from './components/layout';

import $ from "jquery";
window.$ = window.jQuery = $;

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API = process.env.REACT_APP_API_URL || "http://localhost:8080";

function logVisit(page) {
  fetch(`${API}/?url=visitor/log`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ page }),
  }).catch(() => {});
}

function App() {

  const location = useLocation();

  useEffect(() => {
    logVisit(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
        if (location.hash) {
      const el = document.getElementById(location.hash.replace("#", ""));
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100); // delay ensures DOM is loaded
      }
    }

    var fullHeight = function () {
      $('.js-fullheight').css('height', $(window).height());

      $(window).resize(function () {
        $('.js-fullheight').css('height', $(window).height());
      });
    };
    fullHeight();

    // loader
    setTimeout(function () {
      if ($('#ftco-loader').length > 0) {
        $('#ftco-loader').removeClass('show');
      }
    }, 1);


    // COUNTER
    const counterSection = document.querySelector('#section-counter');

    if (counterSection) {

      const counterObserver = new IntersectionObserver((entries, observer) => {

        entries.forEach(entry => {

          if (entry.isIntersecting) {

            const numbers = entry.target.querySelectorAll('.number');

            numbers.forEach(el => {

              const target = parseInt(el.dataset.number);
              let count = 0;

              const interval = setInterval(() => {

                count += Math.ceil(target / 100);

                if (count >= target) {
                  el.textContent = target;
                  clearInterval(interval);
                } else {
                  el.textContent = count;
                }

              }, 20);

            });

            observer.unobserve(entry.target);

          }

        });

      }, { threshold: 0.4 });

      counterObserver.observe(counterSection);
    }


    // SCROLL ANIMATION
    const elements = document.querySelectorAll('.ftco-animate');

    const animationObserver = new IntersectionObserver((entries, observer) => {

      entries.forEach(entry => {

        if (entry.isIntersecting) {

          entry.target.classList.add('fadeInUp', 'ftco-animated');

          observer.unobserve(entry.target);

        }

      });

    }, { threshold: 0.2 });

    elements.forEach(el => animationObserver.observe(el));

  }, [location]); // 👈 run on route change
  

  return <Layout />;
}

export default App;